export const regexExp = {
  emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phoneRegex: /^(?:\d{10}|\d{3}-\d{3}-\d{4}|)$/,
  passwordRegex:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\x20-\x7E])[A-Za-z\d\x20-\x7E]{8,}$/,
  nameRegex: /^[A-Za-z\s!@#$%^&*()_+{}[\]:;<>,.?~\\-]+$/,
  linkRegex: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i
};
